/*
	libJwt.js
*/
import { Auth } from 'aws-amplify';
import { baseURL, logger } from '../baselineApis';
import { baseURLEnum } from './enums/baseURL';
import { apiEndpointEnum } from './enums/apiEndpoints';
import { configureAmplify } from './amplify';
import { wrappedTypeResponse } from './enums/wrappedTypeResponse';
import { FetchError } from './fetchError';


export const getAuthorizationToken = async () => {
  try {
    configureAmplify();
    const session = await Auth.currentSession();
    const result = await session?.getIdToken().getJwtToken();
    return result;
  } catch (e) {
    logger.error({
      message: 'website: getAuthTokenError',
      error: e,
      function: getAuthorizationToken.name,
    });
  }
};

export const getBaselineJWTFromBaseline = async() => {
  const columbiaJWT = await getAuthorizationToken();
  const url = `${baseURL(baseURLEnum.BASELINE_JWT_SERVICE)}/${apiEndpointEnum.CREATE}`;

  const request = new Request(url, 
  {
      method:"GET",
      headers:{
        Authorization: columbiaJWT,
        accept: '*/*',
      } 
    });
  
  return fetch(request).then((response)=>{return response.text(); });
}

export function getBaselineJWTFromLocalStorage() {
  const value = localStorage.getItem('baselineJWT');
  return value;
}

export function setBaselineJWTInLocalStorage(value) {
  localStorage.setItem('baselineJWT', value);
}

export function clearBaselineJWTFromLocalStorage() {
  localStorage.removeItem('baselineJWT');
}

const isTokenPopulated = (token) => token !== undefined && token !== null && token !== '';

async function getAndUpdateBaselineJWT() {
  return getBaselineJWTFromBaseline().then((result) => {
    if (result != null && result != '') {
      setBaselineJWTInLocalStorage(result);
    }
    return result;
  });
}

export const getBaselineJWT = async () => {
  const baselineJWT = getBaselineJWTFromLocalStorage()
  if (!isTokenPopulated(baselineJWT)) {
    return getAndUpdateBaselineJWT().then((response)=>{return response});
  } 
  return baselineJWT;
};

async function responseToType(response, responseType){
  let convert_func = null;

  switch(responseType)
  {
  case wrappedTypeResponse.JSON:
    convert_func = async ()=>{return response.json();}
    break;
  case wrappedTypeResponse.TEXT:
    convert_func = async ()=>{return response.text();}
    break;
  case wrappedTypeResponse.BLOB:
    convert_func = async ()=>{return response.blob();}
    break;
  case wrappedTypeResponse.ARRAYBUFFER:
    convert_func = async ()=>{return response.arraybuffer();}
    break;
  default:
    convert_func = null;
  }

  if (convert_func)
  {
    try {
      return convert_func();
    }
    catch(e)
    {
      logger.warn(`responseToType failed to convert data to ${responseType}`)
    }
  }
  return response;
}

export function baselineJWTExpiredWrapper(fn, responseType) {
  return async (...args) => {
    return fn(...args)
     .then((response)=> {
        if (response.ok) {
          return responseToType(response, responseType).then((converted_result) =>{
            return converted_result;
          })
        }                
		
        if (response?.status === 401) {
          return response?.text().then((response_text)=>{
            if (response_text === "expired") {
              return getBaselineJWTFromBaseline().then((newJWT)=>{
                setBaselineJWTInLocalStorage(newJWT);
                return fn(...args).then((second_response)=>{
                  response = second_response;
                  if (second_response.ok) {
                    return responseToType(second_response,responseType).then((converted_result)=> {
                        return converted_result;
                    })
                  }
                  return Promise.reject(new FetchError(`failed response - fn:${fn.name} status: ${second_response.status} - url: ${second_response.url}`,response));
                });
              });
            }
          });
        }
        return Promise.reject(new FetchError(`failed response - fn:${fn.name} status: ${response.status} - url: ${response.url}`,response));
     })
  }
}